<template>
    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab
            active
            title="Dados"
        >
            <TabDados
                ref="TabDados"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Dados administrativos">
            <TabDadosAdministrativos
                ref="TabDadosAdministrativos"
                :form="form.dadosAdministrativos"
                :model="model"
            />
        </rkm-tab>

        <rkm-tab title="Local de atendimento">
            <TabInfraestrutura
                ref="TabInfraestrutura"
                :termos-invalidos="form.termosInvalidos"
                :form="form.infraestruturas"
                :model="model"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import TabDados from './tabs/Dados'
import TabDadosAdministrativos from './tabs/DadosAdministrativos'
import TabInfraestrutura from './tabs/Infraestrutura'

export default {
    components: { TabDados, TabDadosAdministrativos, TabInfraestrutura },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
        goToDadosTab() {

            this.tabIndex = 0
        }
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabDados,
            this.$refs.TabDadosAdministrativos,
            this.$refs.TabInfraestrutura,
        ]
    }
}
</script>